import {Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {ControlContainer, NgForm, NgModelGroup} from '@angular/forms';
import * as _ from 'lodash';
import {FuncoesUteisService} from 'src/app/services/commons/funcoes-uteis.service';
import {MetaObjetivoService} from "../../../services/metaObjetivo/meta-objetivo.service";
import {ComboMetaObjetivo} from "../../../core/combo-meta-objetivo";


@Component({
    selector: 'combo-meta-objetivo',
    templateUrl: './combo-meta-objetivo.component.html',
    styleUrls: ['./combo-meta-objetivo.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm},
        {provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup)}],
})
export class ComboMetaObjetivoComponent implements OnInit {

    @Input() showDisplayId;
    @Input() obrigatorio;
    @Input() selecionado;
    @Input() desabilitado;

    @Output() valorChange = new EventEmitter();

    dados = [];
    data: any = {};

    constructor(private metaObjetivoService: MetaObjetivoService,
                private funcoesUteisService: FuncoesUteisService) {
    }

    ngOnInit(): void {
        this.data = Date.now();

        setTimeout(() => {
            this.metaObjetivoService.getAllByCombo().subscribe((metas: ComboMetaObjetivo[]) => {
                this.dados = metas;
                this.preencherComboMetaObjetivo();
                this.dados = this.funcoesUteisService.ordernarArray(this.dados, 'descricao');
            });
        }, 0)

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["selecionado"] && this.selecionado && this.selecionado.id) {
            this.preencherComboMetaObjetivo();
        }
    }

    private preencherComboMetaObjetivo() {
        if (this.selecionado && this.selecionado.id && this.dados.length) {
            this.selecionado = _.find(this.dados, {id: this.selecionado.id});
        }
    }

    onValorChange(registro: any) {
        this.valorChange.emit(registro);
        this.preencherComboMetaObjetivo();
    }

}
